import React, { useState, useCallback } from "react";
import { Menu, X } from "lucide-react";
import DocSidebar from "../components/apiDocs/DocSidebar";
import EndpointDoc from "../components/apiDocs/EndpointDoc";
import ApiPlayground from "../components/apiDocs/ApiPlayground";
import GettingStarted from "../components/apiDocs/GettingStarted";
import AuthSection from "../components/apiDocs/AuthSection";
import ErrorReference from "../components/apiDocs/ErrorReference";
import TemplateSendingGuide from "../components/apiDocs/TemplateSendingGuide";
import {
  API_CATEGORIES,
  ENDPOINTS,
  ERROR_CODES,
  GETTING_STARTED,
  AUTH_SECTION,
  TEMPLATE_GUIDE,
} from "../data/apiDocsData";

const ApiDocs = () => {
  const [activeSection, setActiveSection] = useState("introduction");
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const [playOpen, setPlayOpen] = useState(false);

  const currentEndpoint = ENDPOINTS[activeSection] || null;

  const handleSelect = useCallback((id) => {
    setActiveSection(id);
    setShowMobileSidebar(false);
    setPlayOpen(Boolean(ENDPOINTS[id]));
  }, []);

  const renderMainContent = () => {
    switch (activeSection) {
      case "introduction":
        return <GettingStarted data={GETTING_STARTED} />;
      case "api-key-usage":
        return <AuthSection data={AUTH_SECTION} />;
      case "error-codes":
        return <ErrorReference errors={ERROR_CODES} />;
      case "template-guide":
        return <TemplateSendingGuide guide={TEMPLATE_GUIDE} />;
      default:
        if (currentEndpoint) {
          return (
            <EndpointDoc
              endpoint={currentEndpoint}
              onTryIt={() => setPlayOpen(true)}
            />
          );
        }
        return <GettingStarted data={GETTING_STARTED} />;
    }
  };

  return (
    <div className="apidocs-page">
      <div className="apidocs-topbar">
        <button
          type="button"
          onClick={() => setShowMobileSidebar((v) => !v)}
          className="ping-btn ping-btn-ghost ping-btn-sm apidocs-menu"
        >
          {showMobileSidebar ? <X size={16} /> : <Menu size={16} />}
          Menu
        </button>
        <div>
          <h2>API Docs</h2>
          <p>Ping API reference</p>
        </div>
      </div>

      <div className="apidocs-body">
        <div className={`apidocs-nav-wrap ${showMobileSidebar ? "open" : ""}`}>
          <DocSidebar
            categories={API_CATEGORIES}
            activeSection={activeSection}
            onSelect={handleSelect}
          />
        </div>

        {showMobileSidebar && (
          <div
            className="apidocs-nav-backdrop"
            onClick={() => setShowMobileSidebar(false)}
          />
        )}

        <main className="apidocs-main">
          <div className="apidocs-doc">{renderMainContent()}</div>
        </main>
      </div>

      {playOpen && currentEndpoint && (
        <>
          <div className="ping-drawer-backdrop" onClick={() => setPlayOpen(false)} />
          <aside className="ping-drawer apidocs-play" role="dialog" aria-modal="true">
            <div className="ping-drawer-head">
              <div>
                <h3>Try this endpoint</h3>
                <p>{currentEndpoint.title}</p>
              </div>
              <button
                type="button"
                onClick={() => setPlayOpen(false)}
                className="ping-btn ping-btn-ghost ping-btn-sm"
              >
                <X size={16} />
              </button>
            </div>
            <div className="apidocs-play-body">
              <ApiPlayground endpoint={currentEndpoint} />
            </div>
          </aside>
        </>
      )}
    </div>
  );
};

export default ApiDocs;
